import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    components: {
        LiveWechatPage: { component: 'Viewport' },
        LiveWechatView: {
            component: 'Card',
            content: { component: 'LiveWechatDataTable' },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/live-wechatData',
                    breadcrumbName: '直播管理',
                    component: 'LiveWechatPage',
                    childRoutes: [
                        {
                            path: '/',
                            breadcrumbName: '微信直播间数据',
                            component: 'LiveWechatView',
                        },
                    ],
                },
            ],
        },
    ],
};
